export default "__VITE_ASSET__1a120d58__"